export interface FaqItem {
  question: string;
  answer: string;
}

export interface CommentItem {
  nickname: string;
  role: string;
  avatarHue: string;
  text: string;
  likes: number;
}

export const site = {
  brand: '校园爆点',
  brandEn: 'CAMPUS BUZZ',
  slogan: '这届学生的瓜，都在这里',
  desc: '校园爆点是一档聚焦校园风云人物与身边趣闻的泛娱乐内容站，用轻松有梗的方式盘点班长学委、社团名场面、毕业照黑历史与人物反差瞬间。',
  email: 'hello@campusbuzz.example',
  columns: [
    { key: 'celebrities', name: '风云人物' },
    { key: 'monitor', name: '班长学委' },
    { key: 'clubs', name: '社团名场面' },
    { key: 'grad', name: '毕业照黑历史' },
    { key: 'contrast', name: '反差瞬间' },
  ],
};

export const hotComments: CommentItem[] = [
  {
    nickname: '图书馆占座侠',
    role: '大三 · 自习区',
    avatarHue: 'bg-secondary-500',
    text: '笑死，自习室一哥那个开头我直接共情，坐他对面的我每天都在看现场版。',
    likes: 1286,
  },
  {
    nickname: '五食堂钉子户',
    role: '大二 · 干饭人',
    avatarHue: 'bg-accent-500',
    text: '食堂阿姨弹钢琴那期我看了三遍，阿姨比我们认真多了，从此排队都不催了。',
    likes: 974,
  },
  {
    nickname: '三号楼情报员',
    role: '大一 · 新生',
    avatarHue: 'bg-primary-500',
    text: '刚入学就看到班长名场面，现在我一喊开会全宿舍都乖乖到齐，这招真的好用。',
    likes: 861,
  },
  {
    nickname: '被拍黑历史的我',
    role: '研一 · 学姐',
    avatarHue: 'bg-secondary-500',
    text: '毕业照那张学士帽起飞照简直是我本人，感谢你们把青春拍得这么真实又好笑。',
    likes: 703,
  },
];

export const faqs: FaqItem[] = [
  {
    question: '站内的校园故事是真实发生的吗？',
    answer: '「校园爆点」是一档娱乐化的内容盘点站。站内的人物、班级与社团故事均为编辑部结合真实校园生活场景创作编写的示例内容，主要提供轻松有趣、有代入感的阅读体验，请勿将站内人物与现实同学、老师对应。',
  },
  {
    question: '这些「风云人物」和「班长学委」的故事从哪来？',
    answer: '内容灵感来自常见的校园场景，例如点名册、班会、社团招新、毕业合影等。我们会把熟悉的片段加工成有梗有温度的短篇盘点，让你在其中找到自己校园生活的影子。',
  },
  {
    question: '我也有想分享的社团名场面或黑历史，可以投稿吗？',
    answer: '当然可以。你可以通过页面底部的联系方式把素材发给我们，编辑部筛选后会用匿名、不泄露隐私的方式整理成文。发布前会做脱敏处理，绝不指向具体真人。',
  },
  {
    question: '为什么有的故事看起来很夸张？',
    answer: '为了增强可读性，部分情节带有一定的戏剧化加工与夸张表达，属于娱乐化叙事的一部分，请当作「段子型盘点」阅读，不必对号入座。',
  },
  {
    question: '会持续更新新的栏目和内容吗？',
    answer: '会。编辑部会持续补充风云人物、社团名场面等不同栏目的新盘点，也会根据读者反馈不定期推出新的校园主题专题。',
  },
];